/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AggregateOperationDto } from './aggregate-operation-dto';
import { FiltersDto } from './filters-dto';
/**
 *
 *
 * @export
 * @interface GroupByDto
 */
export interface GroupByDto {
  /**
   * When set, truncs the timestamp columns to the desired unit before grouping.
   *
   * @type {string}
   * @memberof GroupByDto
   * @example month
   */
  date_trunc_unit?: GroupByDtoDateTruncUnitEnum;

  /**
   * Column aggregations to run.
   *
   * @type {Array<AggregateOperationDto>}
   * @memberof GroupByDto
   * @example [{"aggregate_function":"count","column":"user"}]
   */
  aggregate_operations?: Array<AggregateOperationDto>;

  /**
   * @type {FiltersDto}
   * @memberof GroupByDto
   */
  filters?: FiltersDto;
}

/**
 * @export
 * @enum {string}
 */
export enum GroupByDtoDateTruncUnitEnum {
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}
